import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import css from './bfm.css';

class ConfirmationForm extends React.Component {

    onLink = (bankAccountId) => {
        const { isRAH, isR1, isR1BankAccount } = this.props;
        const feed = {...this.props.feed};
        if (isRAH) feed.RAHBankAccountId = bankAccountId || null;
        if (isR1) {
          if (isR1BankAccount) feed.oldR1BankAccountId = feed.R1BankAccountId;  
          feed.R1BankAccountId = bankAccountId || null;
        }
        this.props.onLink(feed);
    }

  render() {
    const { feed, onBack, selectedBankaccount, isRAH } = this.props;

    const info = [
        '. Are you sure you want to change the linked bank account? All future coded transactions will be imported to the newly linked account.',
      ];
    const unlinkInfo = [
        'You are about to unlink the account (',
        <strong>{feed.accountName}</strong>,
        '), you will no longer be able to code any transaction once this is done. Do you want to save this change?'
      ];

    return (
        <div>
            <DialogContent className={[css.w400, css.mt20].join(' ')}>
                {selectedBankaccount && selectedBankaccount.length !== 0 ?
                    <DialogContentText id="alert-dialog-description">
                        You've selected 
                        <span className={css.cardHeading}>
                            <strong>{` '${selectedBankaccount.AccountName}'`}</strong>
                        </span>
                            {info}
                    </DialogContentText> :
                    <DialogContentText id="alert-dialog-description">
                            {unlinkInfo}
                    </DialogContentText> 
                }                    
            </DialogContent>
            <div className={css.borderBottom} />
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Button variant="contained" onClick={onBack}>Back</Button>
                <Button variant="contained" color="primary" onClick={() => this.onLink(selectedBankaccount && isRAH ? selectedBankaccount.RAHBankAccountId: selectedBankaccount && selectedBankaccount.R1BankAccountID)}>Save</Button>
            </div>
        </div>
    );
  }
}

ConfirmationForm = reduxForm({
  form: 'linkFeedForm',
})(ConfirmationForm);

const selector = formValueSelector('linkFeedForm');

ConfirmationForm = connect(state => {
  const selectedBankaccount = selector(state, 'bankAccount');
  return { selectedBankaccount };
})(ConfirmationForm);

export default ConfirmationForm;



// WEBPACK FOOTER //
// ./src/components/FeedManagment/ConfirmationForm.js